// IdentityBadge.jsx
// Tiny fixed pill showing who is signed in — rendered on staff routes only
// (App.js withBadge wrapper). Never on public/customer/overlay routes.
// Tap collapses it to a dot (sticky per device) for screens where it crowds.

import { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import ArtistAvatar from "./ArtistAvatar";
import { STAFF_THEME, FONT } from "../theme/staff";

const BRAND = STAFF_THEME;
const COLLAPSE_KEY = "gt_identity_badge_collapsed";

export default function IdentityBadge({ user, roleInfo }) {
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem(COLLAPSE_KEY) === "true"
  );
  // The signed-in person's registry entry (matched by login email) — carries
  // their customized avatar. Missing entry → emoji fallback below.
  const [me, setMe] = useState(null);
  useEffect(() => {
    if (!user?.email) { setMe(null); return; }
    const q = query(collection(db, "artists"), where("email", "==", user.email));
    return onSnapshot(q, (snap) => setMe(snap.empty ? null : snap.docs[0].data()), () => setMe(null));
  }, [user?.email]);
  if (!user) return null;

  const isArtist = roleInfo?.role === "artist";
  const icon = isArtist ? "🎨" : "👑";
  const name = roleInfo?.displayName || user.displayName || user.email?.split("@")[0] || "Staff";

  function toggle() {
    setCollapsed((c) => {
      localStorage.setItem(COLLAPSE_KEY, String(!c));
      return !c;
    });
  }

  return (
    <button
      onClick={toggle}
      title={`${user.email || ""}${isArtist ? " (artist)" : " (admin)"}`}
      style={{
        position: "fixed",
        left: "0.6rem",
        bottom: "0.6rem",
        zIndex: 9500,
        display: "flex",
        alignItems: "center",
        gap: collapsed ? 0 : "0.35rem",
        background: "rgba(13,24,51,0.88)",
        border: `1px solid ${BRAND.border}`,
        borderRadius: "999px",
        padding: collapsed ? "0.3rem" : "0.28rem 0.7rem 0.28rem 0.45rem",
        color: BRAND.text,
        fontFamily: FONT.display,
        fontSize: "0.74rem",
        fontWeight: 700,
        cursor: "pointer",
        boxShadow: "0 2px 10px rgba(0,0,0,0.35)",
        lineHeight: 1,
      }}
    >
      {me?.avatar
        ? <ArtistAvatar avatar={me.avatar} size={collapsed ? 20 : 22} />
        : <span style={{ fontSize: "0.85rem" }}>{icon}</span>}
      {!collapsed && <span>{name}</span>}
    </button>
  );
}
